import React, { useEffect, useState } from 'react';

import Registration from './Registration';
import RegistrationFail from './RegistrationFail';
import RegistrationResponse from '../models/RegistrationResponse';
import RegistrationSuccess from './RegistrationSuccess';

export interface RegistrationContainerProps {
  invitationToken?: string;
  email?: string;
  onCompleted: (userkey: number) => void;
}

const RegistrationContainer = (props: RegistrationContainerProps) => {
  const [registered, setRegistered] = useState<boolean>();
  const [email, setEmail] = useState(props.email || '');
  const [verificationEmailSent, setVerificationEmailSent] = useState(false);

  useEffect(() => setEmail(props.email), [props.email]);

  const handleRegisterCompleted = (response: RegistrationResponse, email: string) => {
    const newUserkey = response?.userkey || -1;
    if (props.invitationToken && newUserkey > 0) {
      props.onCompleted(newUserkey);
      return <p>Registration succeeded.</p>;
    }
    setRegistered(newUserkey > 0);
    setEmail(email);
    setVerificationEmailSent(newUserkey > 0 && response?.emailVerificationRequired);
  }

  return (
    <div className={ registered !== undefined ? 'membership-content' : ''}>
    {
      registered === undefined
      &&
      <Registration
        invitationToken={props.invitationToken}
        email={email}
        onRegisterCompleted={handleRegisterCompleted}
      />
    }
    {
      registered === true
      &&
      <RegistrationSuccess
        email={email}
        verificationEmailSent={verificationEmailSent}
      />
    }
    {
      registered === false
      &&
      <RegistrationFail />
    }
    </div>
  )
}

export default RegistrationContainer;
